"use strict";

exports.__esModule = true;
exports.StyledSelect = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const hasError = ({
  meta,
  readOnly
}) => {
  if (readOnly || !meta) return false;
  const {
    touched,
    error
  } = meta;
  return touched && error;
};

const Caret = color => `"data:image/svg+xml,%3Csvg width='15px' height='9px' viewBox='0 0 15 9' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round'%3E%3Cg transform='translate(-328.000000, -705.000000)' stroke='${encodeURIComponent(color)}' stroke-width='2'%3E%3Cpolyline points='342 706 335.5 712 329 706'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/svg%3E"`;

const StyledSelect = _styledComponents.default.select`
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    width: auto;
    margin-bottom: 0;
    max-width: 100%;
    border: 1px solid ${({
  theme
}) => theme.colors.select.border};
    border-radius: 3px;
    font-size: 16px;
    height: 50px;
    padding: 5px 45px 5px 15px;
    -webkit-padding-end: 45px !important;
    -webkit-padding-start: 15px !important;
    color: ${({
  theme
}) => theme.colors.select.text};
    background: ${({
  theme
}) => `url(${Caret(theme.colors.select.caret)}) no-repeat top right ${theme.colors.select.background}`};
    background-color: ${props => hasError(props) ? props.theme.colors.select.error.background : props.theme.colors.select.background};
    border: 1px solid ${props => hasError(props) ? props.theme.colors.select.error.border : props.theme.colors.select.border};
    background-position: calc(100% - 15px) center !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &::-ms-expand {
        display: none;
    }

    &:focus {
        background-color: ${props => hasError(props) ? props.theme.colors.select.focus.error.background : props.theme.colors.select.focus.background};
        border-color: ${props => hasError(props) ? props.theme.colors.select.focus.error.border : props.theme.colors.select.focus.border};
    }
`;
exports.StyledSelect = StyledSelect;